/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type QuickViewItem_item = {
    readonly title: string | null;
    readonly linkData: {
        readonly path: string | null;
    };
    readonly quickViewDisplay: {
        readonly title: string | null;
        readonly mobileTitle: string | null;
        readonly paragraphs: ReadonlyArray<{
            readonly key: string | null;
            readonly text: string | null;
            readonly mobileText: string | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"QuickViewCategoryParagraph_item" | "QuickViewCreators_item">;
    readonly " $refType": "QuickViewItem_item";
};
export type QuickViewItem_item$data = QuickViewItem_item;
export type QuickViewItem_item$key = {
    readonly " $data"?: QuickViewItem_item$data;
    readonly " $fragmentRefs": FragmentRefs<"QuickViewItem_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "showCreatorLinksQuicklook"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuickViewItem_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewDisplayType",
      "kind": "LinkedField",
      "name": "quickViewDisplay",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "mobileTitle",
          "args": (v1/*: any*/),
          "kind": "ScalarField",
          "name": "title",
          "storageKey": "title(formatType:\"MOBILE\")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "QuickViewParagraph",
          "kind": "LinkedField",
          "name": "paragraphs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            {
              "alias": "mobileText",
              "args": (v1/*: any*/),
              "kind": "ScalarField",
              "name": "text",
              "storageKey": "text(formatType:\"MOBILE\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuickViewCategoryParagraph_item"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "showCreatorLinksQuicklook",
          "variableName": "showCreatorLinksQuicklook"
        }
      ],
      "kind": "FragmentSpread",
      "name": "QuickViewCreators_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = '141ce10899ff9fafb0167e617337d7c9';
export default node;
